/**
 * YEDEK BANDI — yalnızca ANORMALLİK varsa görünür (07 §4e).
 *
 *  - otomatik yedek kurulu ama yazılamıyor (bağlantı yenilenmeli / hata),
 *  - otomatik yedek KAPALI ve defter DOLU: veri yalnızca bu tarayıcıda,
 *  - eşitlemede ÇAKIŞMA: aynı kaydı iki cihaz da değiştirmiş, sonraki
 *    tutuldu (kaybeden sessizce gitmesin; ayrıntı Ayarlar'da). Kapatılabilir.
 *
 * İkincisi de bir anormallik: 27.09.2026'da tam bu durumda "Clear site data"
 * defteri sildi. Boş defterde bant yok — korunacak bir şey yok.
 */

import { M } from "../dil";
import { useState } from "react";
import { useMutation } from "../repo/useAsync";
import { routeHref } from "../lib/router";
import { HEDEF_ADI } from "../yedek/tipler";
import { useYedek } from "../yedek/YedekSaglayici";
import { Button, InlineError } from "../ui/primitives";

export function YedekBandi() {
  const y = useYedek();
  const run = useMutation();
  const [kapatilan, setKapatilan] = useState<string | null>(null);
  if (y === null) return null;
  const { durum, defterBos } = y;

  const e = durum.esitleme;
  if (e !== null && e.cakismalar.length > 0 && kapatilan !== e.zaman) {
    return (
      <div role="status" className="flex flex-wrap items-center gap-2 border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        <span>{M.yedek.bant.cakisma(e.cakismalar.length)}</span>
        <a className="underline" href={routeHref("ayarlar")}>
          {M.ortak.ayrinti}
        </a>
        <Button className="!py-0.5 text-[12px]" onClick={() => setKapatilan(e.zaman)}>
          {M.ortak.tamam}
        </Button>
      </div>
    );
  }

  if (durum.kurulu === true && durum.baglantiGerekli) {
    const metin =
      durum.hedefTuru === null ? M.yedek.bant.bekliyorBuluta : M.yedek.bant.bekliyorHedef(HEDEF_ADI[durum.hedefTuru]);
    return (
      <div role="status" className="flex flex-wrap items-center gap-2 border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        <span>{metin}</span>
        <Button className="!py-0.5 text-[12px]" disabled={run.pending} onClick={() => void run.run(() => y.yenidenBaglan())}>
          {M.yedek.depolama.yenidenBaglan}
        </Button>
        {run.error !== undefined && <InlineError error={run.error} />}
      </div>
    );
  }
  if (durum.kurulu === true && durum.hata !== null) {
    return (
      <div role="status" className="border-b border-danger-border bg-danger-soft px-4 py-1.5 text-[12px] text-danger">
        {M.yedek.bant.yazilamadi(durum.hata.mesaj)}{" "}
        <a className="underline" href={routeHref("ayarlar")}>
          {M.yedek.bant.ayarlar}
        </a>
      </div>
    );
  }
  if (durum.kurulu === false && defterBos === false) {
    return (
      <div role="status" className="border-b border-warn-border bg-warn-soft px-4 py-1.5 text-[12px] text-warn">
        {M.yedek.bant.yalnizcaTarayicida}{" "}
        <a className="underline" href={routeHref("ayarlar")}>
          {M.yedek.bant.ayarlarDepolama}
        </a>
      </div>
    );
  }
  return null;
}
